module.exports = __webpack_public_path__ + "img/good_default_small.ba7ace38.png";